// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"14cf2ed8","428":"cd8d3b7a"}[chunkId] + ".chunk.css";
};